export class CadastroUsuarioLote {
    idOrganizacao: number;
    arqBase64: string;
    fileName: string;
    emailAdm: string;
}